import React from "react";
import {BrowserRouter, Route, Switch} from 'react-router-dom'
import { Navbar, Sidebar, Footer } from "./components";
import {AboutScreen, AttractionsScreen, ContactScreen, ErrorScreen, HomeScreen, RoutesScreen, SingleAttraction, Map} from './screen'


function App() {
  return (
    <BrowserRouter className="">
      <Navbar/>
      <Sidebar/>
      <Switch>
        <Route path="/" exact component={HomeScreen}/>
        <Route path="/percorsi" component={RoutesScreen}/>
        <Route path="/attrazioni" exact component={AttractionsScreen}/>
        <Route path="/attrazioni/:id" component={SingleAttraction}/>
        <Route path="/about" component={AboutScreen}/>
        <Route path="/contattaci" component={ContactScreen}/>
        <Route path="/mappa" component={Map}/>
        <Route path="*" component={ErrorScreen}/>
      </Switch>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
